/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentDownload } from './DocumentDownload';
import {
    DocumentDownloadFromJSON,
    DocumentDownloadFromJSONTyped,
    DocumentDownloadToJSON,
    DocumentDownloadToJSONTyped,
} from './DocumentDownload';

/**
 * 
 * @export
 * @interface DocumentDownloadResponse
 */
export interface DocumentDownloadResponse {
    /**
     * 
     */
    data: DocumentDownload;
}

/**
 * Check if a given object implements the DocumentDownloadResponse interface.
 */
export function instanceOfDocumentDownloadResponse(value: object): value is DocumentDownloadResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function DocumentDownloadResponseFromJSON(json: any): DocumentDownloadResponse {
    return DocumentDownloadResponseFromJSONTyped(json, false);
}

export function DocumentDownloadResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentDownloadResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': DocumentDownloadFromJSON(json['data']),
    };
}

export function DocumentDownloadResponseToJSON(json: any): DocumentDownloadResponse {
    return DocumentDownloadResponseToJSONTyped(json, false);
}

export function DocumentDownloadResponseToJSONTyped(value?: DocumentDownloadResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DocumentDownloadToJSON(value['data']),
    };
}

